export default __webpack_public_path__ + "static/media/Bildschirmfoto 2020-12-16 um 20.59 1.735d9dda.jpg";